<template>
    <div
        class="reset-pw-page"
        :style="{'background-image': `url(${require('@/assets/login-bg.jpg')})`}">
        <div class="top-left-logo">
            <img src="@/assets/logo-trans.png" />
        </div>
        <div class="top-right-lang">
            <ChangeLang />
        </div>
        <v-card
            width="570"
            outlined>
            <v-card-text class="card-input">
                <div class="logo-container">
                    <img src="@/assets/olaf-logo.png" />
                </div>
                <div class="sub-header-reset-pw locale-font">
                    {{ $vuetify.lang.t('$vuetify.resetPassword.createYourPassword') }}
                </div>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>
                    <v-text-field
                        class="locale-font"
                        :label="this.$vuetify.lang.t('$vuetify.resetPassword.newPassword')"
                        v-model="form.newPassword"
                        :placeholder="this.$vuetify.lang.t('$vuetify.resetPassword.enterNewPassword')"
                        :type="inputNewPasswordType"
                        :append-icon="inputNewPasswordType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="toggleInputNewPasswordType()"
                        :rules="newPasswordRules">
                    </v-text-field>
                    <v-text-field
                        class="locale-font"
                        :label="this.$vuetify.lang.t('$vuetify.resetPassword.confirmedPassword')"
                        v-model="form.confirmedPassword"
                        :placeholder="this.$vuetify.lang.t('$vuetify.resetPassword.enterConfirmedPassword')"
                        :type="inputConfirmedPasswordType"
                        :append-icon="inputConfirmedPasswordType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="toggleInputConfirmedPasswordType()"
                        v-on:keyup.enter="onSubmit()"
                        :rules="confirmedPasswordRules">
                    </v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    class="mx-auto my-5"
                    width="264"
                    color="primary"
                    @click="onSubmit()">
                    {{ $vuetify.lang.t('$vuetify.resetPassword.login') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import ChangeLang from '@/components/ChangeLang'

export default {
    name: 'ForgotPassword',

    components: {
        ChangeLang
    },

    data () {
        return {
            valid: true,
            form: {
                newPassword: '',
                confirmedPassword: '',
                token: ''
            },
            inputNewPasswordType: 'password', // passible value text or password
            inputConfirmedPasswordType: 'password', // passible value text or password
            loading: false,
            newPasswordRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.resetPassword.newPasswordIsRequired')
            ],
            confirmedPasswordRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.resetPassword.confirmedPasswordRequired'),
                v => this.form.newPassword === v || this.$vuetify.lang.t('$vuetify.resetPassword.passwordIsNotMatch')
            ]
        }
    },

    methods: {
        async onSubmit () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.$store.dispatch('setLoading', true)

            const res = await this.axios.post('user/reset-password', this.form)

            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)

                this.$router.push({ name: 'Dashboard' }, () => {})
            }
        },

        toggleInputNewPasswordType () {
            if (this.inputNewPasswordType === 'password') {
                this.inputNewPasswordType = 'text'
            } else if (this.inputNewPasswordType === 'text') {
                this.inputNewPasswordType = 'password'
            }
        },

        toggleInputConfirmedPasswordType () {
            if (this.inputConfirmedPasswordType === 'password') {
                this.inputConfirmedPasswordType = 'text'
            } else if (this.inputConfirmedPasswordType === 'text') {
                this.inputConfirmedPasswordType = 'password'
            }
        },

        async validateToken () {
            const res = await this.axios.post('user/validate-reset-token', { token: this.form.token })
            // console.log(res)

            if (res && res.data && res.data.status === 'error') {
                this.$router.push({ name: 'ResetPasswordExpired' }, () => {})
            }
        }
    },

    async mounted () {
        if (this.$route.params && this.$route.params.token) {
            this.form.token = this.$route.params.token
        }

        await this.validateToken()
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$utils.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.reset-pw-page {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

    .v-content {
        height: 100%;
    }
}
.logo-container {
    display: flex;
    justify-content: center;
    margin: 2rem 0;
}
.sub-header-reset-pw {
    margin-bottom: 1rem;
    font-weight: 500;
    text-align: center;
    color: black;
    font-size: 16px;
}
.card-input {
    padding: 0rem 5rem;
}
</style>
